import { X, Calendar } from "lucide-react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface CalendlyNotificationProps {
  userName: string;
  hasCalendlyUrl: boolean;
}

export function CalendlyNotification({ userName, hasCalendlyUrl }: CalendlyNotificationProps) {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  
  // Check if the notification has been dismissed before
  useEffect(() => {
    const isDismissed = localStorage.getItem('calendly-notification-dismissed-candidate');
    
    if (!hasCalendlyUrl && !isDismissed) {
      setIsVisible(true);
    }
  }, [hasCalendlyUrl]);
  
  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('calendly-notification-dismissed-candidate', 'true');
  };
  
  const handleAddCalendlyUrl = () => {
    navigate('/profile');
  };
  
  if (!isVisible) return null;
  
  return (
    <div className="mb-8 p-4 border border-border rounded-sm bg-card shadow-sm">
      <div className="flex justify-between items-start">
        <div className="flex items-start gap-3">
          <div className="bg-primary/10 p-2 rounded-full">
            <Calendar className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-medium text-card-foreground">Set up interview scheduling</h3>
            <p className="text-muted-foreground text-sm mt-1">
              Hey {userName}, add your Calendly URL to make it easy for employers 
              to schedule interviews with you.
            </p>
          </div>
        </div>
        
        <button 
          onClick={handleDismiss} 
          className="text-muted-foreground hover:text-foreground"
          aria-label="Dismiss notification"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      
      <div className="mt-4 flex justify-end">
        <Button 
          onClick={handleAddCalendlyUrl}
          className="bg-primary text-primary-foreground hover:bg-primary/90"
        >
          Add Calendly URL
        </Button>
      </div>
    </div>
  );
}